import React from 'react';
import styled from '@emotion/styled';


const LearningCenterContainer = styled.div`
    background: linear-gradient(90deg, #F6F8F8 0%, #F0F3F4 100%);
    border-radius: 0vw 20vw 20vw 0vw;
   
    width: 900px;
    height: 500px;
   
    left:0rem;
    top:80rem;
    display: grid;
    grid-auto-flow: column;
    grid-row-start:6;
    grid-template-columns: 5rem 30rem 5rem 30rem;
    grid-template-rows: 5rem  2rem 1rem;

`;

const LearnMore = styled.div`
    position: relative;
    width: auto;
    height: 17rem;
    z-index: 1;

    margin-top: 8rem;
    grid-column-start: 2;
    grid-column-end: 3;

    p{
        --text-color: #373B3E;
        width: 20vw;
    
        font-size: 1.2rem;
    
        color: var(--text-color);
    }
    h2{
        font-weight: 500;
        font-size: 2.5rem;
        margin-bottom: 1.5rem;
    
        color: var(--text-color);
    }
`;

const LearnMoreButton = styled.div`
    position: absolute;
    bottom: 0;

    button{
        width: 221px;
        height: 44px; 
        background: #DD6B20;
        box-shadow: 0px 4px 6px rgba(221, 107, 32, 0.08), 0px 10px 15px rgba(221, 107, 32, 0.12);
        border-radius: 44px;
        color: rgb(255, 243, 235);

        align-items: center;
        justify-content: center;

        font-size: 1.2rem;
        font-weight: 500;

        text-decoration: none;

        position: relative;

        z-index: 2;
    }
    .dot-matrix{
        width: 136px;
        height: 98px;
        position: absolute;
        right: 140px;
        top: 1px;
    }
`;

const LearningCardContainer = styled.div`
    display: flex;
    flex-direction: row;
    grid-row-end: 1;
    grid-column-end: 4;
    z-index: 1;
    justify-content: space-between;
    margin-top: 8rem;

    .learning-card{
        display: grid;
        grid-auto-flow: row;
        
        
        margin-right: 1rem;
        background: #FFFFFF;
        /* shadow-base */
        
        box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.12);
        border-radius: 40px;
    
            padding: 25px;
    }
    .card-title{
        font-family: Inter;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 14px;
        /* identical to box height, or 100% */
    
        padding-left:10px;
        /* default/neutral-gray/600 */
    
        color: #757575;
    }
    .card-heading{
        padding-left:10px;
        font-family: Inter;
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 24px;
        /* identical to box height, or 100% */
    
    
        /* default/gray/800 */
    
        color: #353B40;
    }
    .card-description{
        padding-left:10px;
        font-family: Inter;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
        width:200px;
        /* or 143% */
    
    
        /* default/gray/700 */
    
        color: #525B64;
    }
   
    .percentage{
        color: #DD6B20;
    }
`;

export default function LearningCenter() {
    return (
       
            <LearningCenterContainer>
                <LearnMore>
                    <h2>Learning Center</h2>
                    <p>Get information on illnesses common to our dispora.</p>
                    <LearnMoreButton>
                        <button href='#0' className='learn-more--btn'>Learn More</button>
                        <img alt='dot graphic' className='dot-matrix' src='/header/display-3-aux/frame-133.svg' />
                    </LearnMoreButton>
                </LearnMore>
                <LearningCardContainer>
                    <div className='learning-card' id='eczema'>
                        <span className='card-title'>Dermatology</span>
                        <h3 className='card-heading'>Eczema</h3>
                        <p className='card-description'>Different stages and types of eczema affect <span className='percentage'>31.6%</span> of people in Jamaica.</p>
                        <a type='button' className='read--more' href='#0'><img src='/learning-center/button.svg' alt='Read More' /></a>
                    </div>
                    <div className='learning-card' id='liver-disease'>
                        <span className='card-title'>Hepatology</span>
                        <h3 className='card-heading'>Liver Disease</h3>
                        <p className='card-description'>Over time, damage to the liver results in scarring (cirrhosis), which can lead to liver failure, a life-threatening condition.</p>
                        <a type='button' className='read--more' href='#0'><img src='/learning-center/button.svg' alt='Read More' /></a>
                    </div>
                </LearningCardContainer>
            </LearningCenterContainer>
  
    );
}
